import { render, staticRenderFns } from "./pr-badge.vue?vue&type=template&id=58fbf938&functional=true"
import script from "./pr-badge.vue?vue&type=script&lang=ts"
export * from "./pr-badge.vue?vue&type=script&lang=ts"
import style0 from "./pr-badge.vue?vue&type=style&index=0&id=58fbf938&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports